import { useEffect, useState } from 'react';
import Alti from "./Alti";

const AltiPage = ({ }) => {
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [screenHeight, setScreenHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const handleResize = () => setScreenHeight(window.innerHeight);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    var totalWith = Math.min(screenHeight - 70, screenWidth)

    return (
        <div style={{
            position: "absolute",
            top: 0,
            left: 0,
        }}>
            <Alti width={totalWith} />
        </div>);
};

export default AltiPage;